function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Card");

var SvgCards = function SvgCards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("rect", {
    x: 5,
    y: 20.94,
    width: 86,
    height: 16.86,
    rx: 1.61,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 5,
    y: 39.57,
    width: 86,
    height: 16.86,
    rx: 1.61,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 5,
    y: 58.2,
    width: 86,
    height: 16.86,
    rx: 1.61,
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CARDS.fb5dbd63.svg";
export { ForwardRef as ReactComponent };